import React from 'react'
import Sidebar, { SidebarItem } from '../Sidebar/Sidebar'
import ProductsSummary from '../ProductsSummary/ProductsSummary'
import HelpNav from '../HelpNav'
import DnaplateProductSummary from '../DnaplateProductSummary/DnaplateProductSummary'
import BitubeProductSummary from '../../products/BiTube/BitubeProductSummary/BitubeProductSummary'
import { useRouter } from '@src/routes'
import { ActiveLinkType } from '../../utils/enum'
import {
  ActiveLinkTypeDnaplate,
  PlateProduct,
} from '../../products/DnaPlates/enum'
import { BiTubeProduct } from '../../products/BiTube/enum'
import { GenomicProduct } from '../../products/Genomics/enum'
interface LeftNavProps {
  sidebarItems: SidebarItem[]
  productType: string
  addProductsFromSideNav?:
    | React.Dispatch<React.SetStateAction<boolean>>
    | null
    | boolean
  setActive: React.Dispatch<React.SetStateAction<any>>
  activeStep: number
  productDetails?: any
  langZh?: boolean
  isNotNavigateable?: boolean
  displayErrorPopUpOnReview?: any
}

const LeftNav: React.FC<LeftNavProps> = ({
  sidebarItems,
  productType,
  addProductsFromSideNav,
  setActive,
  activeStep,
  productDetails,
  langZh,
  isNotNavigateable,
  displayErrorPopUpOnReview,
}) => {
  const router = useRouter()
  const activeLink = router?.query?.activeLink ?? ''

  if (productType === BiTubeProduct.BiTube) {
    return (
      <>
        <Sidebar
          items={sidebarItems}
          activeStep={activeStep}
          isNotNavigateable={isNotNavigateable}
          displayErrorPopUpOnReview={displayErrorPopUpOnReview}
        />
        {activeLink === ActiveLinkType.ConfirmOrder ||
        activeLink === ActiveLinkType.ReviewPage ||
        addProductsFromSideNav ? (
          ''
        ) : (
          <BitubeProductSummary
            productDetails={productDetails}
            setActive={setActive}
          />
        )}
        {activeLink !== ActiveLinkType.ConfirmOrder &&
        activeLink !== ActiveLinkType.ReviewPage ? (
          <HelpNav
            country={productDetails.countryCode}
            product={productDetails.productType}
          />
        ) : (
          ''
        )}
      </>
    )
  } else if (
    productType === PlateProduct.DnaPlate ||
    productType === PlateProduct.DuplexPlate
  ) {
    return (
      <>
        <Sidebar items={sidebarItems} activeStep={activeStep} langZh={langZh} />
        {activeLink === ActiveLinkTypeDnaplate.OligoConfiguration ? (
          <DnaplateProductSummary productDetails={productDetails} />
        ) : (
          ''
        )}
        <HelpNav
          country={productDetails.countryCode}
          product={productDetails.productType}
        />
      </>
    )
  } else if (
    productType === 'milliplex' ||
    productType === 'antisera' ||
    productType === 'simpleantisera'
  ) {
    return (
      <>
        <Sidebar items={sidebarItems} activeStep={activeStep} />
        <HelpNav
          country={productDetails.countryCode}
          product={productDetails.productType}
        />
      </>
    )
  } else if (productType === GenomicProduct.CustomCrispr) {
    return (
      <>
        <Sidebar items={sidebarItems} activeStep={activeStep} />

        <HelpNav
          country={productDetails.countryCode}
          product={productDetails.productType}
        />
      </>
    )
  } else {
    return (
      <>
        <Sidebar
          items={sidebarItems}
          activeStep={activeStep}
          isNotNavigateable={isNotNavigateable}
          displayErrorPopUpOnReview={displayErrorPopUpOnReview}
        />
        {activeLink === ActiveLinkType.ConfirmOrder ||
        activeLink === ActiveLinkType.ReviewPage ||
        addProductsFromSideNav ? (
          ''
        ) : (
          <ProductsSummary
            productType={productType}
            addItemsFromSideNav={addProductsFromSideNav}
            setActive={setActive}
          />
        )}
        <HelpNav
          country={productDetails.countryCode}
          product={productDetails.productType}
        />
      </>
    )
  }
}
export default LeftNav
